// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./fontawesome.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Epilogue-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Epilogue-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Epilogue-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Epilogue-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Epilogue-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Epilogue-SemiBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/Epilogue-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/Epilogue-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/Epilogue-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/Epilogue-SemiBold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/Epilogue-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/Epilogue-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/Epilogue-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/Epilogue-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/Epilogue-Medium.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/Epilogue-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/Epilogue-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/Epilogue-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/Epilogue-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/Epilogue-Light.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../images/login-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#Epilogue-Regular" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#Epilogue-SemiBold" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#Epilogue-Medium" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#Epilogue-Light" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Epilogue";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Epilogue";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("svg");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Epilogue";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("svg");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Epilogue";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("svg");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  color: #11142d;
}
p,
li,
body {
  font-family: "Inter", sans-serif;
  color: #474848;
  font-size: 14px;
  font-weight: normal;
}
* {
  box-sizing: border-box;
}
.btn-primary {
  background: #1e75ff;
  color: #fff !important;
  position: relative;
  border: 0;
  font-size: 14px;
  border-radius: 10px;
  font-weight: 500;
  width: 100%;
}
.btn.btn-primary,
.btn.btn-secondary {
  padding: 12px 30px;
}
.btn.btn-primary:hover,
.btn-primary.focus,
.btn-primary:focus,
.btn:focus {
  background: #1e1f25;
  box-shadow: none !important;
}
input.btn.btn-primary:hover,
input.btn.btn-secondary:hover,
input.btn.btn-secondary:focus {
  background: #1e1f25;
}
.btn-secondary {
  color: #fff;
  background-color: #8950fc;
  border-color: #8950fc;
  font-weight: bold;
}
.btn-secondary:hover,
.btn-secondary:focus {
  background-color: #4ab58e;
  border-color: #4ab58e;
}
img {
  max-width: 100%;
}
.text-dark {
  color: #000 !important;
}
.col-white * {
  color: #fff;
}
a {
  color: #0bb783;
  transition: 0.3s;
}
a:hover {
  color: #11142d;
  text-decoration: inherit;
}
ul {
  padding-left: 20px;
}
.h1,
h1 {
  font-size: 42px;
}
.h2,
h2 {
  font-size: 24px;
}
.h3,
h3 {
  font-size: 24px;
}
.h4,
h4 {
  font-size: 22px;
}
.h5,
h5 {
  font-size: 16px;
}
.text-gray {
  color: #11142d;
  opacity: 0.5;
}
.font-weight-600 {
  font-weight: 600;
}
.font-weight-800 {
  font-weight: 600;
  text-align: left;
  padding-left: 23px;
  padding-top: 11px;
}

.font-weight-700 {
  font-weight: 600;
}
.font-weight-500 {
  font-weight: 500;
}

.form-control {
  border: 1px solid #3c4254;
  border-radius: 10px;
  font-size: 14px;
  padding: 12px 17px;
  min-height: auto;
  height: auto;
  color: #757b8c !important;
  outline: 0 !important;
  box-shadow: none !important;
  background: #1e1f25;
}
.form-control:focus,
.form-control:active {
  background: #1e1f25;
  color: #757b8c !important;
  border-color: #1e75ff;
}
input::-webkit-input-placeholder {
  /* Edge */
  color: #757b8c;
  opacity: 1;
}
input:-ms-input-placehlder {
  /* Internet Explorer 10-11 */
  color: #757b8c;
  opacity: 1;
}
input::placeholder {
  color: #757b8c;
  opacity: 1;
}

.bg-white {
  background: #fff;
}
.bg-gray-gradient {
  background: rgb(248, 249, 250);
  background: linear-gradient(
    90deg,
    rgba(248, 249, 250, 1) 0%,
    rgba(237, 238, 242, 1) 50%,
    rgba(249, 250, 251, 1) 100%
  );
}

.spin {
  text-align: center;
  width: 400px;
  margin: 0 auto;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
}

.purple-gradient {
  background: rgb(234, 197, 226);
  background: linear-gradient(
    90deg,
    rgba(235, 238, 254, 1) 0%,
    rgba(237, 238, 242, 1) 50%,
    rgba(235, 238, 254, 1) 100%
  );
}

.blue-gradient {
  background: rgb(235, 238, 254);
  background: linear-gradient(
    90deg,
    rgba(235, 238, 254, 1) 0%,
    rgba(237, 238, 242, 1) 50%,
    rgba(235, 238, 254, 1) 100%
  );
}
.bg-gray {
  background: #edeef2;
}
.red-gradient {
  background: rgb(254, 235, 236);
  background: linear-gradient(
    90deg,
    rgba(254, 235, 236, 1) 0%,
    rgba(237, 238, 242, 1) 50%,
    rgba(254, 235, 235, 1) 100%
  );
}
.pink-gradient {
  background: rgb(255, 235, 254);
  background: linear-gradient(
    90deg,
    rgba(255, 235, 254, 1) 0%,
    rgba(237, 238, 242, 1) 50%,
    rgba(255, 235, 254, 1) 100%
  );
}
/*----login page----*/
.login-sec {
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.login-box {
  max-width: 500px;
  margin: 0 auto;
  -webkit-backdrop-filter: blur(20px) brightness(1.3);
  backdrop-filter: blur(20px) brightness(1.3);
  border-radius: 20px;
}

/*------Dashboard page------*/
.service-menu {
  border-radius: 20px;
}
.navbar .navbar-nav {
  flex-direction: column;
}
.page-body {
  min-height: 100vh;
}
.left-sidebar,
.right-content {
  min-height: 100vh;
}
.left-sidebar {
  width: 380px;
  position: fixed;
  padding: 30px 30px 0 30px;
  display: flex;
  flex-direction: column;
}
.right-content {
  width: 100%;
  padding-left: 410px !important;
}
.u-img {
  height: 45px;
  width: 45px;
  min-width: 45px;
  border-radius: 10px;
}

.navbar{
  flex-direction: column !important;
}

.sidebar-column .sidebar .nav-item.active .xdr-link#xdr-box1{
  background: #3e8bf71f;
}

.sidebar-column .sidebar .nav-item.active .xdr-link#xdr-box2{
  background: #d1a2f82e;
}

.sidebar-column .sidebar .nav-item.active .xdr-link#xdr-box3{
  background: #ffa2a224;
}

.sidebar-column .sidebar .nav-item.active .xdr-link#xdr-box4{
  background: #ffa2bf2e;
}


.xdr-right-icon{
  margin-left: 15px;
}

.navbar .navbar-nav .nav-item {
  margin-bottom: 10px;
  cursor: pointer;
}
.navbar .navbar-nav .nav-item .nav-link {
  padding: 15px;
  border-radius: 10px;
}
.navbar .navbar-nav .nav-item.active .nav-link {
  background: #ebeeff;
}
.navbar .navbar-nav .nav-item:nth-child(2).active .nav-link {
  background: #f4ebff;
}
.navbar .navbar-nav .nav-item:nth-child(3).active .nav-link {
  background: #ffebeb;
}
.navbar .navbar-nav .nav-item:nth-child(4).active .nav-link {
  background: #ffebfe;
}
.navbar .navbar-nav .nav-item.active .nav-link .nav-title h5::after {
  content: "\\f054";
  font-family: "Font Awesome 5 Free", sans-serif;
  font-weight: 900;
  float: right;
}
.rating-sec {
  background: #282c38;
  border-radius: 5px;
  border: 1px solid #3c4254;
  padding: 8px 25px;
  color: #ffb545;
  width: auto;
  display: inline-block;
  font-size: 15px;
}
.radius-20 {
  border-radius: 20px;
}
.p-text {
  color: #757b8c;
}
.powerd-sec {
  border-top: 1px solid #e4e4e4;
}
.icon-img {
  width: 88px;
  height: 88px;
  padding: 10px;
  background: #efeff2;
  border-radius: 100%;
  margin: 0 auto 25px;
}
.card {
  box-shadow: 0 0 20px 1px rgb(0 0 0 / 4%);
  border: 0 !important;
  margin-bottom: 30px;
}
.box-cont-body {
  min-height: 225px;
}
.icon-img img {
  max-width: 50px;
  max-height: 50px;
}
.card-body h2 span {
  font-weight: 500;
  font-size: 18px;
}
.handhovertext {
  font-size: 32px;
}
.task-column {
  background: #f7f9fb;
  border-radius: 12px;
  padding: 15px;
}

.handhover-page *:not(i) {
  font-family: "Epilogue", sans-serif;
}
.handhover-page h1,
.handhover-page h2,
.handhover-page h3,
.handhover-page h4,
.handhover-page h5 {
  color: #464e5f;
}
.task-list {
  border-radius: 12px;
  padding: 18px;
  margin-bottom: 15px;
}
.progress {
  height: 8px;
}
.progress-bar {
  border-radius: 1.25rem;
}
.paper-text {
  color: #bcbcbc;
}
span.doc-number {
  font-size: 12px;
  display: inline-block;
  position: relative;
  top: 1px;
}
.badge-success {
  background-color: #c9f7f5;
  color: #1bc5bd;
}
.badge-danger {
  background-color: rgba(246, 78, 96, 0.12);
  color: #f64e60;
}
.badge {
  font-weight: normal;
  font-size: 12px;
  line-height: 1.4;
  padding: 4px 5px 1px;
  margin-left: 4px;
}

.scrollbar {
  width: 300px;
  height: 100px;
  overflow-y: scroll;
  scrollbar-color: rebeccapurple green;
  scrollbar-width: thin;
}

.opacitynew {
  opacity: 0.4;
}
.user-t {
  height: 24px;
  width: 24px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffd7a3;
  color: #f64e60;
  font-size: 12px;
  font-weight: bold;
  border-radius: 100%;
  margin-left: 3px;
}
.user-list img {
  margin-left: 3px;
}
.powerd-sec div:last-child img {
  max-height: 22px;
}
@media only screen and (max-width: 1350px) {
  .right-content {
    padding-left: 360px !important;
  }
  .left-sidebar {
    width: 328px;
  }
  .task-list {
    padding: 15px;
  }
}
@media only screen and (max-width: 767px) {
  .left-sidebar {
    width: 100%;
    position: relative;
    display: block;
  }
  .left-sidebar,
  .right-content {
    min-height: auto;
  }
  .right-content {
    padding: 15px !important;
  }
  .h1,
  h1 {
    font-size: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAIA;EACE,uBAAuB;EACvB,4CAAyC;EACzC;;;;yDAIqE;EACrE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,4CAA0C;EAC1C;;;;0DAIuE;EACvE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,6CAAwC;EACxC;;;;0DAImE;EACnE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,6CAAuC;EACvC;;;;0DAIiE;EACjE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;;;EAME,kCAAkC;EAClC,iBAAiB;EACjB,cAAc;AAChB;AACA;;;EAGE,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;AACA;;EAEE,kBAAkB;AACpB;AACA;;;;EAIE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,cAAc;EACd,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAa9B;;;;;GAKC;AACH;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAa9B;;;;;GAKC;AACH;;AAEA;EACE,8BAA8B;EAa9B;;;;;GAKC;AACH;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAa9B;;;;;GAKC;AACH;AACA;EACE,8BAA8B;EAa9B;;;;;GAKC;AACH;AACA,qBAAqB;AACrB;EACE,aAAa;EACb,4BAA4B;EAC5B,kCAAkC;EAClC,sBAAsB;EACtB,0DAA+C;AACjD;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,mDAAmD;EACnD,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mCAAmC;AACrC;AACA;;;;;EAKE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,cAAc;EAChB;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,eAAe;EACjB;AACF","sourcesContent":["@import \"../css/fontawesome.css\";\n\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap\");\n\n@font-face {\n  font-family: \"Epilogue\";\n  src: url(\"../fonts/Epilogue-Regular.eot\");\n  src: url(\"../fonts/Epilogue-Regular.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"../fonts/Epilogue-Regular.woff2\") format(\"woff2\"),\n    url(\"../fonts/Epilogue-Regular.woff\") format(\"woff\"),\n    url(\"../fonts/Epilogue-Regular.ttf\") format(\"truetype\"),\n    url(\"../fonts/Epilogue-Regular.svg#Epilogue-Regular\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Epilogue\";\n  src: url(\"../fonts/Epilogue-SemiBold.eot\");\n  src: url(\"../fonts/Epilogue-SemiBold.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"../fonts/Epilogue-SemiBold.woff2\") format(\"woff2\"),\n    url(\"../fonts/Epilogue-SemiBold.woff\") format(\"woff\"),\n    url(\"../fonts/Epilogue-SemiBold.ttf\") format(\"truetype\"),\n    url(\"../fonts/Epilogue-SemiBold.svg#Epilogue-SemiBold\") format(\"svg\");\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Epilogue\";\n  src: url(\"../fonts/Epilogue-Medium.eot\");\n  src: url(\"../fonts/Epilogue-Medium.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"../fonts/Epilogue-Medium.woff2\") format(\"woff2\"),\n    url(\"../fonts/Epilogue-Medium.woff\") format(\"woff\"),\n    url(\"../fonts/Epilogue-Medium.ttf\") format(\"truetype\"),\n    url(\"../fonts/Epilogue-Medium.svg#Epilogue-Medium\") format(\"svg\");\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Epilogue\";\n  src: url(\"../fonts/Epilogue-Light.eot\");\n  src: url(\"../fonts/Epilogue-Light.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"../fonts/Epilogue-Light.woff2\") format(\"woff2\"),\n    url(\"../fonts/Epilogue-Light.woff\") format(\"woff\"),\n    url(\"../fonts/Epilogue-Light.ttf\") format(\"truetype\"),\n    url(\"../fonts/Epilogue-Light.svg#Epilogue-Light\") format(\"svg\");\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: bold;\n  color: #11142d;\n}\np,\nli,\nbody {\n  font-family: \"Inter\", sans-serif;\n  color: #474848;\n  font-size: 14px;\n  font-weight: normal;\n}\n* {\n  box-sizing: border-box;\n}\n.btn-primary {\n  background: #1e75ff;\n  color: #fff !important;\n  position: relative;\n  border: 0;\n  font-size: 14px;\n  border-radius: 10px;\n  font-weight: 500;\n  width: 100%;\n}\n.btn.btn-primary,\n.btn.btn-secondary {\n  padding: 12px 30px;\n}\n.btn.btn-primary:hover,\n.btn-primary.focus,\n.btn-primary:focus,\n.btn:focus {\n  background: #1e1f25;\n  box-shadow: none !important;\n}\ninput.btn.btn-primary:hover,\ninput.btn.btn-secondary:hover,\ninput.btn.btn-secondary:focus {\n  background: #1e1f25;\n}\n.btn-secondary {\n  color: #fff;\n  background-color: #8950fc;\n  border-color: #8950fc;\n  font-weight: bold;\n}\n.btn-secondary:hover,\n.btn-secondary:focus {\n  background-color: #4ab58e;\n  border-color: #4ab58e;\n}\nimg {\n  max-width: 100%;\n}\n.text-dark {\n  color: #000 !important;\n}\n.col-white * {\n  color: #fff;\n}\na {\n  color: #0bb783;\n  transition: 0.3s;\n}\na:hover {\n  color: #11142d;\n  text-decoration: inherit;\n}\nul {\n  padding-left: 20px;\n}\n.h1,\nh1 {\n  font-size: 42px;\n}\n.h2,\nh2 {\n  font-size: 24px;\n}\n.h3,\nh3 {\n  font-size: 24px;\n}\n.h4,\nh4 {\n  font-size: 22px;\n}\n.h5,\nh5 {\n  font-size: 16px;\n}\n.text-gray {\n  color: #11142d;\n  opacity: 0.5;\n}\n.font-weight-600 {\n  font-weight: 600;\n}\n.font-weight-800 {\n  font-weight: 600;\n  text-align: left;\n  padding-left: 23px;\n  padding-top: 11px;\n}\n\n.font-weight-700 {\n  font-weight: 600;\n}\n.font-weight-500 {\n  font-weight: 500;\n}\n\n.form-control {\n  border: 1px solid #3c4254;\n  border-radius: 10px;\n  font-size: 14px;\n  padding: 12px 17px;\n  min-height: auto;\n  height: auto;\n  color: #757b8c !important;\n  outline: 0 !important;\n  box-shadow: none !important;\n  background: #1e1f25;\n}\n.form-control:focus,\n.form-control:active {\n  background: #1e1f25;\n  color: #757b8c !important;\n  border-color: #1e75ff;\n}\ninput::-webkit-input-placeholder {\n  /* Edge */\n  color: #757b8c;\n  opacity: 1;\n}\ninput:-ms-input-placehlder {\n  /* Internet Explorer 10-11 */\n  color: #757b8c;\n  opacity: 1;\n}\ninput::placeholder {\n  color: #757b8c;\n  opacity: 1;\n}\n\n.bg-white {\n  background: #fff;\n}\n.bg-gray-gradient {\n  background: rgb(248, 249, 250);\n  background: -moz-linear-gradient(\n    90deg,\n    rgba(248, 249, 250, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(249, 250, 251, 1) 100%\n  );\n  background: -webkit-linear-gradient(\n    90deg,\n    rgba(248, 249, 250, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(249, 250, 251, 1) 100%\n  );\n  background: linear-gradient(\n    90deg,\n    rgba(248, 249, 250, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(249, 250, 251, 1) 100%\n  );\n}\n\n.spin {\n  text-align: center;\n  width: 400px;\n  margin: 0 auto;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.purple-gradient {\n  background: rgb(234, 197, 226);\n  background: -moz-linear-gradient(\n    90deg,\n    rgba(235, 238, 254, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(235, 238, 254, 1) 100%\n  );\n  background: -webkit-linear-gradient(\n    90deg,\n    rgba(235, 238, 254, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(235, 238, 254, 1) 100%\n  );\n  background: linear-gradient(\n    90deg,\n    rgba(235, 238, 254, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(235, 238, 254, 1) 100%\n  );\n}\n\n.blue-gradient {\n  background: rgb(235, 238, 254);\n  background: -moz-linear-gradient(\n    90deg,\n    rgba(235, 238, 254, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(235, 238, 254, 1) 100%\n  );\n  background: -webkit-linear-gradient(\n    90deg,\n    rgba(235, 238, 254, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(235, 238, 254, 1) 100%\n  );\n  background: linear-gradient(\n    90deg,\n    rgba(235, 238, 254, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(235, 238, 254, 1) 100%\n  );\n}\n.bg-gray {\n  background: #edeef2;\n}\n.red-gradient {\n  background: rgb(254, 235, 236);\n  background: -moz-linear-gradient(\n    90deg,\n    rgba(254, 235, 236, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(254, 235, 235, 1) 100%\n  );\n  background: -webkit-linear-gradient(\n    90deg,\n    rgba(254, 235, 236, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(254, 235, 235, 1) 100%\n  );\n  background: linear-gradient(\n    90deg,\n    rgba(254, 235, 236, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(254, 235, 235, 1) 100%\n  );\n}\n.pink-gradient {\n  background: rgb(255, 235, 254);\n  background: -moz-linear-gradient(\n    90deg,\n    rgba(255, 235, 254, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(255, 235, 254, 1) 100%\n  );\n  background: -webkit-linear-gradient(\n    90deg,\n    rgba(255, 235, 254, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(255, 235, 254, 1) 100%\n  );\n  background: linear-gradient(\n    90deg,\n    rgba(255, 235, 254, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(255, 235, 254, 1) 100%\n  );\n}\n/*----login page----*/\n.login-sec {\n  height: 100vh;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  background-image: url(\"../images/login-bg.jpg\");\n}\n.login-box {\n  max-width: 500px;\n  margin: 0 auto;\n  -webkit-backdrop-filter: blur(20px) brightness(1.3);\n  backdrop-filter: blur(20px) brightness(1.3);\n  border-radius: 20px;\n}\n\n/*------Dashboard page------*/\n.service-menu {\n  border-radius: 20px;\n}\n.navbar .navbar-nav {\n  flex-direction: column;\n}\n.page-body {\n  min-height: 100vh;\n}\n.left-sidebar,\n.right-content {\n  min-height: 100vh;\n}\n.left-sidebar {\n  width: 380px;\n  position: fixed;\n  padding: 30px 30px 0 30px;\n  display: flex;\n  flex-direction: column;\n}\n.right-content {\n  width: 100%;\n  padding-left: 410px !important;\n}\n.u-img {\n  height: 45px;\n  width: 45px;\n  min-width: 45px;\n  border-radius: 10px;\n}\n\n.navbar{\n  flex-direction: column !important;\n}\n\n.sidebar-column .sidebar .nav-item.active .xdr-link#xdr-box1{\n  background: #3e8bf71f;\n}\n\n.sidebar-column .sidebar .nav-item.active .xdr-link#xdr-box2{\n  background: #d1a2f82e;\n}\n\n.sidebar-column .sidebar .nav-item.active .xdr-link#xdr-box3{\n  background: #ffa2a224;\n}\n\n.sidebar-column .sidebar .nav-item.active .xdr-link#xdr-box4{\n  background: #ffa2bf2e;\n}\n\n\n.xdr-right-icon{\n  margin-left: 15px;\n}\n\n.navbar .navbar-nav .nav-item {\n  margin-bottom: 10px;\n  cursor: pointer;\n}\n.navbar .navbar-nav .nav-item .nav-link {\n  padding: 15px;\n  border-radius: 10px;\n}\n.navbar .navbar-nav .nav-item.active .nav-link {\n  background: #ebeeff;\n}\n.navbar .navbar-nav .nav-item:nth-child(2).active .nav-link {\n  background: #f4ebff;\n}\n.navbar .navbar-nav .nav-item:nth-child(3).active .nav-link {\n  background: #ffebeb;\n}\n.navbar .navbar-nav .nav-item:nth-child(4).active .nav-link {\n  background: #ffebfe;\n}\n.navbar .navbar-nav .nav-item.active .nav-link .nav-title h5::after {\n  content: \"\\f054\";\n  font-family: \"Font Awesome 5 Free\", sans-serif;\n  font-weight: 900;\n  float: right;\n}\n.rating-sec {\n  background: #282c38;\n  border-radius: 5px;\n  border: 1px solid #3c4254;\n  padding: 8px 25px;\n  color: #ffb545;\n  width: auto;\n  display: inline-block;\n  font-size: 15px;\n}\n.radius-20 {\n  border-radius: 20px;\n}\n.p-text {\n  color: #757b8c;\n}\n.powerd-sec {\n  border-top: 1px solid #e4e4e4;\n}\n.icon-img {\n  width: 88px;\n  height: 88px;\n  padding: 10px;\n  background: #efeff2;\n  border-radius: 100%;\n  margin: 0 auto 25px;\n}\n.card {\n  box-shadow: 0 0 20px 1px rgb(0 0 0 / 4%);\n  border: 0 !important;\n  margin-bottom: 30px;\n}\n.box-cont-body {\n  min-height: 225px;\n}\n.icon-img img {\n  max-width: 50px;\n  max-height: 50px;\n}\n.card-body h2 span {\n  font-weight: 500;\n  font-size: 18px;\n}\n.handhovertext {\n  font-size: 32px;\n}\n.task-column {\n  background: #f7f9fb;\n  border-radius: 12px;\n  padding: 15px;\n}\n\n.handhover-page *:not(i) {\n  font-family: \"Epilogue\", sans-serif;\n}\n.handhover-page h1,\n.handhover-page h2,\n.handhover-page h3,\n.handhover-page h4,\n.handhover-page h5 {\n  color: #464e5f;\n}\n.task-list {\n  border-radius: 12px;\n  padding: 18px;\n  margin-bottom: 15px;\n}\n.progress {\n  height: 8px;\n}\n.progress-bar {\n  border-radius: 1.25rem;\n}\n.paper-text {\n  color: #bcbcbc;\n}\nspan.doc-number {\n  font-size: 12px;\n  display: inline-block;\n  position: relative;\n  top: 1px;\n}\n.badge-success {\n  background-color: #c9f7f5;\n  color: #1bc5bd;\n}\n.badge-danger {\n  background-color: rgba(246, 78, 96, 0.12);\n  color: #f64e60;\n}\n.badge {\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 1.4;\n  padding: 4px 5px 1px;\n  margin-left: 4px;\n}\n\n.scrollbar {\n  width: 300px;\n  height: 100px;\n  overflow-y: scroll;\n  scrollbar-color: rebeccapurple green;\n  scrollbar-width: thin;\n}\n\n.opacitynew {\n  opacity: 0.4;\n}\n.user-t {\n  height: 24px;\n  width: 24px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #ffd7a3;\n  color: #f64e60;\n  font-size: 12px;\n  font-weight: bold;\n  border-radius: 100%;\n  margin-left: 3px;\n}\n.user-list img {\n  margin-left: 3px;\n}\n.powerd-sec div:last-child img {\n  max-height: 22px;\n}\n@media only screen and (max-width: 1350px) {\n  .right-content {\n    padding-left: 360px !important;\n  }\n  .left-sidebar {\n    width: 328px;\n  }\n  .task-list {\n    padding: 15px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .left-sidebar {\n    width: 100%;\n    position: relative;\n    display: block;\n  }\n  .left-sidebar,\n  .right-content {\n    min-height: auto;\n  }\n  .right-content {\n    padding: 15px !important;\n  }\n  .h1,\n  h1 {\n    font-size: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
